import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../utils/http";

export const login = createAsyncThunk(
    "auth/login",
    async ({ identifier, password }, { rejectWithValue }) => {
        try {
            const res = await http.post("/auth/local", { identifier, password });
            const { jwt, user } = res.data;
            localStorage.setItem("jwt", jwt);
            return { jwt, user };
        } catch (err) {
            return rejectWithValue(err.response?.data?.error?.message || "Ошибка входа");
        }
    }
);

export const logout = createAsyncThunk("auth/logout", async () => {
    localStorage.removeItem("jwt");
    return null;
});

const slice = createSlice({
    name: "auth",
    initialState: {
        token: localStorage.getItem("jwt"),
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                state.token = action.payload.jwt;
                state.user = action.payload.user;
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(logout.fulfilled, (state) => {
                state.token = null;
                state.user = null;
            });
    },
});

export default slice.reducer;
